import React from 'react';
import i18next from 'i18next';

import { fixDecimal } from 'utils/general';
import { currency } from 'globals/currency';
import SimpleTableWithSorting, { generateColumn, TableCellProps } from '../common/SimpleTableWithSorting';

const CurrencyFormatterCell = (props: TableCellProps<unknown>) => (
  <div>
    {fixDecimal(props.getValue())} {currency}
  </div>
);

interface IProps {
  data: {
    name: string;
    orders_count: number;
    orders_price: number;
    orders_avg: number;
    orders_commission_sum: number;
    restaurant_commission: number;
  }[]
}
const RestaurantOrderValuesTable: React.FC<IProps> = ({ data }) => {
  const tableData = React.useMemo(() => data, [data]);

  const columns = React.useMemo(
    () => [
      generateColumn('name', {
        customHeader: i18next.t('restaurant-order-values-table.restaurant-name'),
      }),
      generateColumn('orders_count', {
        customHeader: i18next.t('restaurant-order-values-table.orders-count'),
      }),
      generateColumn('orders_price', {
        customHeader: i18next.t('restaurant-order-values-table.orders-turnover'),
        customCellFormatter: CurrencyFormatterCell,
      }),
      generateColumn('orders_avg', {
        customHeader: i18next.t('restaurant-order-values-table.orders-avg'),
        customCellFormatter: CurrencyFormatterCell,
      }),
      generateColumn('orders_commission_sum', {
        customHeader: i18next.t('restaurant-order-values-table.orders-commission-sum'),
        customCellFormatter: CurrencyFormatterCell,
      }),
      generateColumn('restaurant_commission', {
        customHeader: i18next.t('restaurant-order-values-table.restaurant-commission'),
        customCellFormatter: CurrencyFormatterCell,
      }),
    ],
    []
  );

  return <SimpleTableWithSorting data={tableData} columns={columns} />;
};

export default RestaurantOrderValuesTable;
